exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--dark-gray:#21282d;--rasp:#ae0e47;--red:#f82b2b}*,:after,:before{box-sizing:border-box}body,html{height:100vh;overflow:hidden;font-size:15px}body{margin:0;font-family:Montserrat,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;color:#fff}.app{height:100%;overflow:hidden;position:relative}.line{width:6px;background-color:var(--rasp);position:absolute;top:50%;left:3.5rem;z-index:10;transform:translateY(-40%);animation:line-grow .8s ease-in-out forwards 1.5s}@media (max-width:991px){.line{transform:translateY(-50%)}}@media (max-width:767px){.line{left:1.5rem}}.text-red{color:var(--red)}.hide{display:none}@keyframes line-grow{0%{height:0}to{height:100%}}@media (max-width:991px){.hide-tablet{display:none}}@media (max-width:767px){.hide-mobile{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2358f84e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 15
// module chunks = 0